/**
 * @generated SignedSource<<29f02298765b6b0377b2209f7b7fcef9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePriceSimulationScenarioInput = {
  id: string;
};
export type AnalysisSimulationViewDeleteScenarioMutation$variables = {
  input: DeletePriceSimulationScenarioInput;
};
export type AnalysisSimulationViewDeleteScenarioMutation$data = {
  readonly deletePriceSimulationScenario: {
    readonly id: string;
  };
};
export type AnalysisSimulationViewDeleteScenarioMutation = {
  response: AnalysisSimulationViewDeleteScenarioMutation$data;
  variables: AnalysisSimulationViewDeleteScenarioMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "deletePriceSimulationScenario",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisSimulationViewDeleteScenarioMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisSimulationViewDeleteScenarioMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94989876ee55ce23acae1afd37dfa89a",
    "id": null,
    "metadata": {},
    "name": "AnalysisSimulationViewDeleteScenarioMutation",
    "operationKind": "mutation",
    "text": "mutation AnalysisSimulationViewDeleteScenarioMutation(\n  $input: DeletePriceSimulationScenarioInput!\n) {\n  deletePriceSimulationScenario(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "97e1679b688e8b2b85dcbc1d805db09d";

export default node;
